


























import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import HealthCheckService from '@/domain/health-check/service/health-check.service';
import LatencyCircle from './latency-circle.component.vue';

const REASONABLE_PING = 1300;
const BAD_PING = 4000;

@Component({ components: { LatencyCircle } })
export default class LatencyComponent extends Vue {
  ping: number = 0;

  error: boolean = false;

  get color(): string {
    if (this.error || this.ping > BAD_PING) return '#C80000';
    if (this.ping < REASONABLE_PING) return '#00C800';
    const maxColor = 200;

    const ratio = this.getRatio();
    const greenColor = this.getGreenColor(maxColor, ratio);
    const redColor = this.getRedColor(maxColor, ratio);

    return `#${this.toHex(redColor)}${this.toHex(greenColor)}00`;
  }

  private getRatio(): number {
    const normalizedPing = this.ping - REASONABLE_PING;
    const normalizedBadPing = BAD_PING - REASONABLE_PING;
    return normalizedPing / normalizedBadPing;
  }

  private toHex(num: number): string {
    const hex = num.toString(16);
    if (num < 16) {
      return `0${hex}`;
    }
    return hex;
  }

  private getGreenColor(maxColor: number, ratio: number): number {
    if (ratio <= 0.5) return maxColor;
    const doubleRatioComplement = (1 - ratio) * 2;
    return Math.floor(maxColor * doubleRatioComplement);
  }

  private getRedColor(maxColor: number, ratio: number): number {
    if (ratio >= 0.5) return maxColor;
    return Math.floor(maxColor * ratio * 2);
  }

  get pingMessage(): String {
    if (this.ping < REASONABLE_PING) {
      return 'A conexão com o servidor está ótima.';
    }
    if (this.ping < BAD_PING) {
      return 'A conexão com o servidor está razoável.';
    }
    return 'A conexão com o servidor está lenta.'
  }

  refreshPing(): void {
    const beforeResponse = moment();
    HealthCheckService.checkServerHealth().then(({ data }: any) => {
      const afterResponse = moment();
      if (data.status !== 'UP') {
        this.error = true;
        return;
      }
      this.ping = afterResponse.diff(beforeResponse, 'milliseconds');
      this.error = false;
    }).catch(() => {
      this.error = true;
    });
  }

  created(): void {
    this.refreshPing();
    setInterval(this.refreshPing, 30000);
  }
}
